import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';

@Component({
    selector: 'app-buyer-announcement-table',
    templateUrl: './buyer-announcement-table.component.html',
    styleUrls: ['./buyer-announcement-table.component.css']
})
export class BuyerAnnouncementTableComponent implements OnInit {

    @Input() list: any[] = [];

    @Output() sort = new EventEmitter<any>();


    dataSource = new MatTableDataSource<any>();


    readColumns: String[] = [

        'title',
        'moderNm',
        'modDt',
        'hitCnt'

    ];

    displayedColumns = [
        'cdNmFr',
        'title',
        'instNm',
        'moderNm',
        'modDt',
        'hitCnt'];

    displayedColumnsAR = [
        'cdNmAr',
        'title',
        'instNm',
        'moderNm',
        'modDt',
        'hitCnt'];
    displayedColumnsen = [
        'cdNm',
        'title',
        'instNm',
        'moderNm',
        'modDt',
        'hitCnt'];

    constructor(
        private translate: AppTranslateService,
    ) {


        /*  this.translate.onLangChange.subscribe(lang => {
            this.currentLang = lang;
            if (this.translate.currentLang='ar'){
              this.readColumns=[]
            return  this.readColumns=[
                'lawClCd',
                'title2',
                'moderNm',
                'modDt',
                'hitCnt'
              ];
            }
            if (this.translate.currentLang='fr'){
              this.readColumns=[]
              return this.readColumns=[
                'lawClCd',
                'title',
                'moderNm',
                'modDt',
                'hitCnt'
              ];
            }
              }); */


    }

    ngOnInit(): void {

        this.loadDataSource();


    }

    getlangue() {

        return this.translate.getDefaultLang() == 'ar';
    }

    getcol() {


        if (this.getlangue()) {
            return this.displayedColumnsAR;
        } else if (this.translate.getDefaultLang() == 'en') {
            return this.displayedColumnsen;
        } else {
            return this.displayedColumns;
        }
    }

    ngAfterViewInit(): void {

        this.loadDataSource();
    }

    loadDataSource() {
        this.dataSource.data = this.list;
    }

    ngOnChanges(changes: SimpleChanges): void {

        const {list} = changes;
        if (list.currentValue !== list.previousValue) {
            this.loadDataSource();
        }
    }

    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }


}
